class RetificarDeclaracaoAnalise{
  constructor(){
    this.id = null;
    this.motivoRetificacao = null;
    this.status = null;
    this.idDeclaracao = null;
    this.idContribuinte = null;
  }
}

export default RetificarDeclaracaoAnalise